import Chart from "chart.js";

Chart.pluginService.register({
  beforeDraw: function (chart, easing) {
    if (
      chart.config.options.chartArea &&
      chart.config.options.chartArea.backgroundColor
    ) {
      var helpers = Chart.helpers;
      var ctx = chart.chart.ctx;
      var chartArea = chart.chartArea;

      ctx.save();
      ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
      ctx.fillRect(
        chartArea.left,
        chartArea.top,
        chartArea.right - chartArea.left,
        chartArea.bottom - chartArea.top
      );
      ctx.restore();
    }
  },
});

Chart.defaults.scale.gridLines.display = false;
Chart.defaults.scale.gridLines.drawBorder = false;
Chart.defaults.scale.gridLines.color = "white";
Chart.defaults.scale.gridLines.zeroLineColor = "white";

Chart.defaults.scale.ticks.color = "white";
Chart.defaults.scale.ticks.beginAtZero = true;

Chart.defaults.scale.ticks.fontColor = "white";
Chart.defaults.global.legend.display = false;

Chart.defaults.global.elements.rectangle.backgroundColor =
  "rgba(255, 255, 255, 0.85)";
Chart.defaults.global.elements.line.borderColor = "rgba(255, 255, 255, 0.65)";
Chart.defaults.global.elements.line.backgroundColor =
  "rgba(255, 255, 255, 0.85)";

Chart.defaults.global.elements.line.fill = false;

Chart.defaults.global.elements.line.tension = 0.1;
Chart.defaults.global.elements.point.radius = 0;
